module.exports = __webpack_public_path__ + "static/img/vip_ioc_en.87c87fba.png";